/**
 * Rotating copy while `km_report_story` runs (Firebase callable; cold starts).
 * Mirrors the story submit UX in SubmitStoryPage / storyFormLoadingMessages.
 */
import { STORY_WRITE_LOADING_INTERVAL_MS } from '@/lib/storyFormLoadingMessages';

export const STORY_REPORT_LOADING_INTERVAL_MS = STORY_WRITE_LOADING_INTERVAL_MS;

export const STORY_REPORT_LOADING_MESSAGES = [
  'Sending your report…',
  'Connecting to moderation…',
  'Recording your feedback…',
  'Almost done…',
];

export const STORY_REPORT_LOADING_HINT =
  'First report in a while can take a few extra seconds while our servers wake up.';
